// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2S1N1","signatureButtonsRight":"ModalSign_signatureButtonsRight__3aD0r"};